module.exports = require("./chr");